import { render } from "./IconSync.vue?vue&type=template&id=ec260b50"
import script from "./IconSync.vue?vue&type=script&lang=js"
export * from "./IconSync.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__